export default "__VITE_ASSET__a0cc220f__"